import { useSyncExternalStore } from 'react'

import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { getSubscriptionStateKey } from '../../utils/keys/notification.key.js'

export interface SubscriptionState {
  subscribed: boolean
}

/** Follow state of a publisher as last changed in this session; undefined until then. */
export const useSubscriptionState = (
  publisherId?: string,
): SubscriptionState | undefined => {
  const queryClient = useQueryClient()
  const key = getSubscriptionStateKey({ variables: { publisherId } })
  return useSyncExternalStore(
    onChange => queryClient.getQueryCache().subscribe(onChange),
    () =>
      publisherId
        ? queryClient.getQueryData<SubscriptionState>(key)
        : undefined,
    () => undefined,
  )
}
